import { useState } from 'react';

export const useMenu = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const onOpenMenu = (anchorEl: null | HTMLElement) => setAnchorEl(anchorEl);
  const onCloseMenu = () => setAnchorEl(null);

  return {
    anchorEl,
    onOpenMenu,
    onCloseMenu,
  };
};
